import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  docreviewrejected: {
    id: 'account.order.lineitem.state.docreviewrejected.details',
    defaultMessage: 'The fie you delivered isn\'t suitable to print on the product you chose. Please review the delivery specifications again and edit plus redeliver your file',
  },
  cancelled: {
    id: 'account.order.lineitem.state.cancelled.details',
    defaultMessage: 'Cancelled',
  },
  waitingfordocreview: {
    id: 'account.order.lineitem.state.waitingfordocreview.details',
    defaultMessage: 'In progress details',
  },
  waitingforsecondarydocreview: {
    id: 'account.order.lineitem.state.waitingforsecondarydocreview.details',
    defaultMessage: 'In progress details',
  },
  docfeedbackrequested: {
    id: 'account.order.lineitem.state.docfeedbackrequested.details',
    defaultMessage: 'In progress details',
  },
  docreviewinproofing: {
    id: 'account.order.lineitem.state.docreviewproofing.details',
    defaultMessage: 'In progress details',
  },
  docreviewinprogress: {
    id: 'account.order.lineitem.state.docreviewinprogress.details',
    defaultMessage: 'In progress details',
  },
  docreviewapproved: {
    id: 'account.order.lineitem.state.docreviewapproved.details',
    defaultMessage: 'In progress details',
  },
  readyforfulfillment: {
    id: 'account.order.lineitem.state.readyforfulfillment.details',
    defaultMessage: 'In progress details',
  },
  docreviewfailed: {
    id: 'account.order.lineitem.state.docreviewfailed.details',
    defaultMessage: 'In progress details',
  },
  processingcloudlabartwork: {
    id: 'account.order.lineitem.state.processingcloudlabartwork.details',
    defaultMessage: 'In progress details',
  },
  processingcloudlabartworkfailed: {
    id: 'account.order.lineitem.state.processingcloudlabartworkfailed.details',
    defaultMessage: 'In progress details',
  },
  processingcloudlabartworkdone: {
    id: 'account.order.lineitem.state.processingcloudlabartworkdone.details',
    defaultMessage: 'In progress details',
  },
  senttomcp: {
    id: 'account.order.lineitem.state.senttomcp.details',
    defaultMessage: 'In production details',
  },
  fulfillmentrejected: {
    id: 'account.order.lineitem.state.fulfillmentrejected.details',
    defaultMessage: 'In production',
  },
  fulfillmenterror: {
    id: 'account.order.lineitem.state.fulfillmenterror.details',
    defaultMessage: 'In production',
  },
  fulfillmentaccepted: {
    id: 'account.order.lineitem.state.fulfillmentaccepted.details',
    defaultMessage: 'In production',
  },
  printinginprogress: {
    id: 'account.order.lineitem.state.printinginprogress.details',
    defaultMessage: 'In production details',
  },
  shipped: {
    id: 'account.order.lineitem.state.shipped.details',
    defaultMessage: 'Your order has left our factory and is on it\'s way to it\'s destination',
  },
  initial: {
    id: 'account.order.lineitem.state.initial.details',
    defaultMessage: 'Processing details',
  },
  confirmed: {
    id: 'account.order.lineitem.state.confirmed.details',
    defaultMessage: 'Processing details',
  },
  processing: {
    id: 'account.order.lineitem.state.processing.details',
    defaultMessage: 'When the payment is processed we\'ll continue processing your order',
  },
  waitingforartwork: {
    id: 'account.order.lineitem.state.waitingforartwork.details',
    defaultMessage: 'We\'re waiting for your file, once we have that we\'ll continue processing your order',
  },
  held: {
    id: 'account.order.lineitem.state.held.details',
    defaultMessage: 'Processing details',
  },
  editinprogress: {
    id: 'account.order.lineitem.state.editinprogress.details',
    defaultMessage: 'Editing details',
  },
  holdforinjection: {
    id: 'account.order.lineitem.state.holdforinjection.details',
    defaultMessage: 'Processing details',
  },
  waitingforproposal: {
    id: 'account.order.lineitem.state.waitingforproposal.details',
    defaultMessage: 'Processing details',
  },
  unknown: {
    id: 'account.order.lineitem.state.unknown.details',
    defaultMessage: 'Unknown',
  },
});
